import { MentionData, MentionType, MENTION_TAG_REGEX } from '../consts';

interface Template {
  template: string;
  id: string;
  name: string;
  type: MentionType;
  index: number;
  key: number;
}

export function encodeMentionsName(name: string): string {
  return name.replace(/"/g, `\\\"`);
}

export function decodeMentionsName(name: string): string {
  return name.replace(/\\"/g, '"');
}

export function parseMentionsTemplate(text: string): Template[] {
  return Array.from(text.matchAll(MENTION_TAG_REGEX)).map((found, key) => {
    const [template, type, id, name] = found;
    return {
      template,
      id,
      name: decodeMentionsName(name),
      type: type as MentionType,
      index: found.index || 0,
      key,
    };
  });
}

export function parseMentionsText(text: string): MentionData[] {
  return parseMentionsTemplate(text).map(({ type, id, name }) => ({
    id,
    name,
    type,
  }));
}
